<template>
  <v-sheet color="white" elevation="5" rounded class="mt-5 mb-5 pt-3 pb-5 pl-3 pr-3">
    <v-spacer />
    <v-spacer />
    <v-row class="pa-3">
      <v-col>
        <v-row>
          <v-col>
            <datepicker
              :date="date"
              label="Date*"
              v-on:updateDates="updateDate($event)"
            />
          </v-col>
          <v-col>
            <v-select :items="showTypes" :item-text="toItemText" label="Show Type" item-value="showTypeId" v-model="showTypeId"
              @input="$emit('update', $event)" />
          </v-col>
          <v-spacer/>
          <v-col>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details />
          </v-col>  
          <v-col cols="1">            
            <v-btn outlined color="primary" :disabled="results?.length == 0"
                  v-on:click="csvExport()">
                <font-awesome-icon icon="file-download" size="lg" />
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table :headers="showResultsHeaders" :items="results" :search="search" dense 
          :sort-by="['showDate', 'showId']" :sort-desc="[false, false]" multi-sort :items-per-page="-1" fixed-header >
          <template v-slot:item.showDate="{ item }">
            <span>{{ $dateUtils.formatDate(item.showDate) }}</span>
          </template>          
          <template v-slot:item.isScchMajor="{ item }">
            <span v-if="item.isScchMajor != null">
              {{ item.isScchMajor ? 'Yes' : 'No' }}
            </span>
            <span v-else></span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";
import Datepicker from "@/components/common/inputs/DatepickerFormatted.vue";

import showResultsService from "@/services/showResultsService";
import showTypesService from "@/services/showTypesService";
import { ShowType } from "@/types/admin/Show";

const noneOption = [{ showTypeId: "", description: 'All' }] as ShowType[];

export default Vue.extend({
  name: "ShowResultsPage",
  components: { Datepicker },
  data: function () {
    return {
      showResultsHeaders: [
        { text: "Show Date", align: "left", value: "showDate" },
        { text: "Dog Id", align: "left", value: "dogId" },
        { text: "Dog Name", align: "left", value: "dogName" },
        { text: "Descr.", align: "left", value: "description" },
        { text: "City, State", align: "left", value: "cityState" },
        { text: "Country", align: "left", value: "country" },
        { text: "Category", align: "left", value: "category" },
        { text: "Time", align: "left", value: "time" },
        { text: "Division", align: "left", value: "division" },
        { text: "Score", align: "left", value: "score" },
        { text: "SCCH Score", align: "left", value: "scchScore" },
        { text: "SCCH Major", align: "left", value: "isScchMajor" },
        { text: "Place", align: "left", value: "place" },
        { text: "Hit", align: "left", value: "hit" },
        { text: "Pt Sched.", align: "left", value: "cpSched" },
        { text: "# Competing", align: "left", value: "nCompeting" },
        { text: "Handler", align: "left", value: "handler" },
        { text: "Judge", align: "left", value: "judge" },
      ],
      results: [],
      search: "",
      showTypeId: "",
      date: new Date().toISOString().slice(0, 10),
      showTypes: [] as ShowType[],
    };
  },
  methods: {
    toItemText: function (item: ShowType) {
      return item.showTypeId ? `${item.showTypeId}: ${item.description}` : item.description
    },
    updateDate: function (val: any) {
      this.date = val?.date;
    },
    csvExport: function () {
        var filename = `ShowResults_${this.showTypeId == "" ? 'ALL' : this.showTypeId}_${this.date.toString()}.csv`;
        var content = this.results;
        const keys = Object.keys(content[0]);

        const commaSeparatedString = [keys.join(","), content.map(row => keys.map(key => row[key]).join(",")).join("\n")].join("\n")

        const csvBlob = new Blob([commaSeparatedString])
        var link = document.createElement("a");
        var url = URL.createObjectURL(csvBlob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },
  },
  created: function () {
    this.$store.dispatch("changeLoaderStatus", true);
    showResultsService
      .getShowResults({ dateString: this.date, showTypeId: this.showTypeId })
      .then((res) => {
        this.results = res.data;
      })
      .finally(() => this.$store.dispatch("changeLoaderStatus", false));
    showTypesService.getShowTypes()
      .then((data) => {
        this.showTypes = noneOption.concat(data)
      })
      .catch(this.$handleError);
  },
  watch: {
    date(d: string) {
      this.$store.dispatch("changeLoaderStatus", true);
      showResultsService
        .getShowResults({ dateString: d, showTypeId: this.showTypeId })
        .then((res) => {
          this.results = res.data;
        })
       .finally(() => this.$store.dispatch("changeLoaderStatus", false));
    },
    showTypeId(s: string) {
      this.$store.dispatch("changeLoaderStatus", true);
      showResultsService
        .getShowResults({ dateString: this.date, showTypeId: s })
        .then((res) => {
          this.results = res.data;
        })
       .finally(() => this.$store.dispatch("changeLoaderStatus", false));
    },
  },
});
</script>
